import { Fragment, useContext } from 'react';
import './InputComponent.scss';
import MyContext from '../../../02Contexts/Mycontext';
import 'react-input-range/lib/css/index.css';
import SideBarComponent from './SideBarComponent/SideBarComponent';
import logo from './logo.png';

export default function InputComponent() {

    const { location, setLocation, radius, setRadius, list, inputRadius, setInputRadius,
        setList, details, setDetails, map, productList, productType, setProductType } = useContext(MyContext)

    function activeLocation(e) {
        e.preventDefault()

        navigator.geolocation.getCurrentPosition(function (position) {
            let aux_location = { lat: position.coords.latitude, lng: position.coords.longitude }
            setLocation(aux_location)
            localStorage.setItem('location', JSON.stringify(aux_location))
        });
    }

    return (
        <Fragment>
            <MyContext.Provider value={{
                location, setLocation, radius, setRadius, list, setList,
                details, setDetails, map, inputRadius, setInputRadius,
                productList, productType, setProductType
            }}>
                {(location) ?
                    <SideBarComponent />
                    :
                    <div id='input_component'>

                        <h3 id='no_location_title' className=' mt-5 mb-3 mx-3 text-black'>Uma plataforma. Todos os benefícios.</h3>

                        <img src={logo} alt='logo' id='viasoft_logo_home' className='mt-5 mb-5' />

                        {/* <h5 id='no_location_msg' className='my-5 mx-3 text-white'>Quer saber aonde pode usar seu vale?</h5> */}

                        <h5 id='no_location_msg' className='mt-3 mb-5 mx-3'>Para encontrar os estabelecimentos mais próximos a você, por favor, ative sua localização.</h5>

                        <button className='custom_btn full' onClick={(e) => activeLocation(e)}>
                            <p>Usar minha localização</p>
                        </button>
                    </div>
                }
            </MyContext.Provider>
        </Fragment>
    )
}

